import React from "react";
import { Button } from "antd";
import ASUTmanual from "./files/ASUTmanual.pdf";

import styles from "./description.module.css";

class DescriptionTab extends React.Component {
  render() {
    return (
      <div className={styles.descriptionTabContainer}>
        <div>
          <span style={{ fontWeight: "600" }}>
            Интернет-служба (ИС) «Теплоинформ»
          </span>{" "}
          является автоматизированной информационной системой, обеспечивающей
          сбор данных с теплосчетчиков и доступ к ним через сайт
          www.teplo-inform.ru.
        </div>

        <div style={{ paddingTop: "1.4em" }}>
          <span style={{ fontWeight: "600" }}>ИС «Теплоинформ»</span> является
          частным случаем реализации измерительно-вычислительной системы (ИВС)
          АСУТ-601, внесённой в Государственный реестр средств измерений с
          регистрационным номером №. 20435-04.
        </div>

        <div style={{ paddingTop: "1.4em" }}>
          <div style={{ fontWeight: "600" }}>
            ИС «ТЕПЛОИНФОРМ» ОСУЩЕСТВЛЯЕТ СБОР ДАННЫХ СО СЛЕДУЮЩИХ ТИПОВ
            ТЕПЛОСЧЕТЧИКОВ:
          </div>
          ВИС.Т, КМ-5, SA-94/1, SA-94/2M, SA-94/3, ТЭМ-104, ТЭМ-106, ТЭМ-05М,
          Магика, ТАРАН-Т, РПТ-1100, РПТ-2200M, Ирвикон, ВКТ-5, ВКТ-7, ЭСКО-Т,
          Взлет-ТСР, Логика СПТ961, ТеРосс-ТМ, СТД, Ирвикон, УВП-280.
        </div>

        <div style={{ paddingTop: "2em" }}>
          <div style={{ fontWeight: "600" }}>
            ВОЗМОЖНО ТАКЖЕ ПОДКЛЮЧЕНИЕ СЛЕДУЮЩИХ ТЕПЛОСЧЁТЧИКОВ, СЧЁТЧИКОВ ГАЗА,
            СЧЁТЧИКОВ ВОДЫ И ЭЛЕКТРОСЧЁТЧИКОВ, СЕРТИФИЦИРОВАННЫХ В СОСТАВЕ ИВС
            АСУТ-601:
          </div>
          Счетчики СТД, Теплосчётчики - регистраторы ТСР-01, Теплосчетчики
          ТСК-7, Счётчики тепла многофункциональные МАКLО, Расходомеры-счетчики
          ультразвуковые УРСВ-010М «ВЗЛЕТ РС», Расходомеры-счетчики
          ультразвуковые многоканальные УСРВ «ВЗЛЕТ МР», Расходомеры-счётчики
          электромагнитные - «ВЗЛЕТ ЭР», Счётчики-расходомеры РМ-5, Корректоры
          СПГ-761, СПГ 762, СПГ 763, Комплексы многониточные измерительные
          микропроцессорные «Суперфлоу-IIET», Корректоры объёма газа SEVC-D,
          Cчетчики электрической энергии трехфазные ПСЧ-3АР.05, Счётчики
          ватт-часов активной энергии переменного тока статические ПСЧ-4ТАК,
          Счётчики электрической энергии трехфазные ПСЧ-4РП.05.2
        </div>
        <Button className={styles.button} type="primary" size="large">
          <a
            href={ASUTmanual}
            donwload="Руководство по эксплуатации АСУТ-601М2"
            target="_blank"
            rel="noopener noreferrer"
          >
            ИНСТРУКЦИЯ
              </a>

        </Button>
      </div>
    );
  }
}

export default DescriptionTab;
